import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Reason } from 'modules/service-call/types';
import { ServiceCallsApi } from 'modules/service-call/api';

interface ExplanationStepCompletedProps {
  reasonId: number
}


export const ExplanationStepCompleted: React.FC<ExplanationStepCompletedProps> = ({ reasonId }) => {

  const reasonsQuery = useQuery<Reason[]>(['reasons'], ServiceCallsApi.getReasons);

  const reason = reasonsQuery.data?.find(x => x.id === reasonId);

  return (
    <Stack marginTop={2}>
      <Typography color='text.secondary'>{reason?.title}</Typography>
    </Stack>
  );
};